/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/**
 * Strips leading `<br>` tags from authored rich-text HTML.
 *
 * Hygraph emits a leading line break when an author starts a rich-text field with an empty line.
 * Handles any number of leading breaks in either the void (`<br>`) or self-closing (`<br />`) form.
 *
 * This is cosmetic only — it is not a sanitizer and must not be relied on as one.
 */
export const stripLeadingLineBreaks = (html?: string | null): string => html?.replace(/^(?:\s*<br\s*\/?>)+/i, "") ?? "";
